export default "__VITE_PUBLIC_ASSET__d2129d15__"